module.exports = __webpack_public_path__ + "img/outBanner.32ac68d6.png";